<template>
    <svg
        width="12"
        height="12"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M9 5l7 7-7 7"
            :stroke="buttonColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            fill="none"
        />
    </svg>
</template>

<script setup>
    import { useAccountStore } from '~/stores/accountStore.ts';

    const { buttonColor } = useAccountStore().state;
</script> 
